/** The primary cell's API, the base every client's default URL is built on. */
export const PRIMARY_API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL || "https://api.dev.us1.harmony.so";
